import { CurrentTermsType } from "api/types";
import Button from "components/common/Button/Button";
import Divider from "components/common/Divider";
import PanelLayout from "components/common/PanelLayout/PanelLayout";
import React, { FunctionComponent, SyntheticEvent, useState } from "react";
import { Col, Row } from "react-grid-system";
import theme from "themes/simple-theme-vh";
import {
  Link,
  TermsAndConditionsButton,
  TermsAndConditionsCheckbox,
  TermsAndConditionsContainer,
  TermsAndConditionsText
} from "./TermsAndConditions.style";
import TermsAndConditionsModal from "./TermsAndConditionsModal";
interface IProps {
  locationName: string;
  nextStep();
  previousStep();
}

const TermsAndConditions: FunctionComponent<IProps> = ({
  locationName,
  previousStep,
  nextStep
}) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [currentTermsType, setCurrentTermsType] = useState();
  const [hasAgreedTcpa, setHasAgreedTcpa] = useState(false);
  const [hasAgreedPrivacy, setHasAgreedPrivacy] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleHasAgreedTcpa = () => setHasAgreedTcpa(!hasAgreedTcpa);
  const handleHasAgreedPrivacy = () => setHasAgreedPrivacy(!hasAgreedPrivacy);

  const handlePreviousStep = () => {
    setModalIsOpen(false);
    setHasAgreedTcpa(false);
    setHasAgreedPrivacy(false);
    previousStep();
  };

  const handleCloseModal = () => setModalIsOpen(false);

  const handlePrivacyPolicyModal = (event: SyntheticEvent<HTMLSpanElement>) => {
    event.stopPropagation();
    if (modalIsOpen) {
      return;
    }
    setModalIsOpen(true);
    setCurrentTermsType(CurrentTermsType.PrivacyPolicy);
  };

  const handleTermsAndConditionsModal = (
    event: SyntheticEvent<HTMLSpanElement>
  ) => {
    event.stopPropagation();
    if (modalIsOpen) {
      return;
    }
    setModalIsOpen(true);
    setCurrentTermsType(CurrentTermsType.TermsAndConditions);
  };

  const handleNextClick = callback => () => {
    setLoading(true);
    callback();
  };

  return (
    <PanelLayout
      title={locationName}
      titleSecondary="Terms and conditions"
      centerContent
    >
      <>
        <TermsAndConditionsContainer>
          <Row align="center">
            <Col>
              <TermsAndConditionsCheckbox
                white
                labelFontSize={theme.fontSize.ms}
                checked={hasAgreedPrivacy}
                onClick={handleHasAgreedPrivacy}
                label={
                  <span>
                    By checking the box and signing up, you consent to receive
                    informational and marketing text messages from or on behalf
                    of {locationName} sent using an automated dialer to the
                    wireless number you provided above. Your consent is not
                    required to make a purchase. You also agree to receive
                    promotional emails.
                  </span>
                }
              />
              <Divider transparent />
              <TermsAndConditionsCheckbox
                white
                labelFontSize={theme.fontSize.ms}
                checked={hasAgreedTcpa}
                onClick={handleHasAgreedTcpa}
                label={
                  <span>
                    By checking the box and signing up, you agree to the{" "}
                    <Link onClick={handleTermsAndConditionsModal}>
                      Terms of Use
                    </Link>{" "}
                    and{" "}
                    <Link onClick={handlePrivacyPolicyModal}>
                      Privacy Policy
                    </Link>
                    .
                  </span>
                }
              />
              <Divider transparent />
              <TermsAndConditionsText>
                You may opt-out of texts any time by replying STOP. You may
                opt-out of emails by clicking the UNSUBSCRIBE link in any
                promotional email.
              </TermsAndConditionsText>
            </Col>
          </Row>
          <Divider transparent />
          <Row justify="center">
            <Col align="center">
              <Button primary onClick={handlePreviousStep}>
                Previous
              </Button>
              <TermsAndConditionsButton
                tertiary
                onClick={handleNextClick(nextStep)}
                disabled={!hasAgreedTcpa || !hasAgreedPrivacy}
                loading={loading}
              >
                Next
              </TermsAndConditionsButton>
            </Col>
          </Row>
        </TermsAndConditionsContainer>
        {modalIsOpen && (
          <TermsAndConditionsModal
            isOpen={modalIsOpen}
            onRequestClose={handleCloseModal}
            currentTermsType={currentTermsType}
          />
        )}
      </>
    </PanelLayout>
  );
};

export default TermsAndConditions;



// WEBPACK FOOTER //
// ./src/screens/Onboarding/WelcomeBoard/TermsAndConditions/TermsAndConditions.tsx